import { Hero } from "./Hero";

export const Home = (): JSX.Element => {
	return <Hero />;
};
